/**
 * Expire every cookie readable from the current document, across all domain and
 * path levels for the current host. Used to start completely fresh — both by the
 * ErrorBoundary "Try again" recovery and by the Curipod-embed reset.
 *
 * Note: only cookies of the current origin are affected; cookies belonging to a
 * (cross-origin) parent frame are not reachable from here and are left intact.
 */
export function clearAllCookies(): void {
  const cookies = document.cookie.split('; ');
  for (let c = 0; c < cookies.length; c++) {
    const d = window.location.hostname.split('.');
    while (d.length > 0) {
      const cookieBase =
        encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
        '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
        d.join('.') +
        ' ;path=';
      const p = window.location.pathname.split('/');
      document.cookie = cookieBase + '/';
      while (p.length > 0) {
        document.cookie = cookieBase + p.join('/');
        p.pop();
      }
      d.shift();
    }
  }
}
